import { ReactNode } from 'react';
import { ComboBoxItem, ComboBoxProps } from '@/components/select/comboBoxTypes';
import MultiComboBox from '@/components/select/MultiComboBox';
import SingleComboBox from '@/components/select/SingleComboBox';

export type { MultiSelectProps, SingleSelectProps } from '@/components/select/selectBoxTypes';
export type {
  AdditiveComboBoxProps,
  ChecklistComboBoxProps,
  ComboBoxProps,
  CommonComboBoxProps as OtherComboBoxSelectProps,
  MultiComboBoxProps,
  SingleComboBoxProps,
} from '@/components/select/comboBoxTypes';
export type Item = ComboBoxItem;

const ComboBox = <T extends ComboBoxItem>(props: ComboBoxProps<T>): ReactNode => {
  if (props.multiple) {
    return <MultiComboBox<T> {...props} />;
  }

  return <SingleComboBox<T> {...props} />;
};

export default ComboBox;
